import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { ConfirmDialogInput } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import { EnterValueInput } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { Gruppe } from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppenService } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.service';
import { GruppeSchweinDialogInput } from '../../../../projects/kiene-core/src/lib/components/gruppen/schweine/gruppe-schweine-dialog/gruppe-schweine-dialog';
import { GruppeSchweineDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppen/schweine/gruppe-schweine-dialog/gruppe-schweine-dialog.component';
import { HitPinAktualisierenDialogComponent } from '../../../../projects/kiene-core/src/lib/components/stammdaten/vvvo/hit-pin-aktualisieren-dialog/hit-pin-aktualisieren-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { KieneSession } from '../../../../projects/kiene-core/src/lib/services/local-storage/kiene-session';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ChangeCurrentClientDialogComponent } from '../../administration/client/change-current-client/change-current-client-dialog/change-current-client-dialog.component';
import { ChangeCurrentClientService } from '../../administration/client/change-current-client/change-current-client.service';

import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    ConditionSetting,
    ConditionTableColumn,
    DateTableColumn,
    KieneBooleanTableColumn,
    NumberTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import {
    HitSyncEinstellungenDialogComponent,
    HitSyncEinstellungenInput,
    HitSyncEinstellungenResult,
} from '../../dialogs/hit-sync-einstellungen-dialog/hit-sync-einstellungen-dialog.component';
import { GruppeDialogInput } from '../../documents/gruppenverwaltung/gruppenuebersicht/gruppe-dialog/gruppe-dialog';
import { GruppeDialogComponent } from '../../documents/gruppenverwaltung/gruppenuebersicht/gruppe-dialog/gruppe-dialog.component';
import { GruppeEditDialogComponent } from '../../documents/gruppenverwaltung/gruppenuebersicht/gruppe-edit-dialog/gruppe-edit-dialog.component';
import { KieneUtils } from '../../kiene-utils';
import { FileDownloadService } from '../../services/file-download.service';
import { GruppeStandortWechselnDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-standort-wechseln-dialog/gruppe-standort-wechseln-dialog.component';
import { GruppeSchweinPopupDialogComponent } from '../schweine/aktuelle-gruppen-schweine/gruppe-schwein-popup-dialog/gruppe-schwein-popup-dialog.component';
import { PhitoStripeService } from '../../../../projects/kiene-core/src/lib/services/phito-stripe.service';

@Component({
    selector: 'kiene-aktuelle-gruppen',
    templateUrl: './aktuelle-gruppen.component.html',
    styleUrls: ['./aktuelle-gruppen.component.scss'],
})
export class AktuelleGruppenComponent implements OnInit, OnDestroy {
    tableDescriptor = new TableDescriptor();
    watchClientSubscription: Subscription;

    kundeColumn: TableColumn;
    kundeZusatzColumn: TableColumn;
    herdenCol: TableColumn;
    abteilCol: TableColumn;
    sgsCol: TableColumn;
    anzahlAktuellCol: TableColumn;
    einstalldatumBisCol: DateTableColumn;
    alterWochenCol: TableColumn;
    anzahlToteCol: TableColumn;
    schlachtIconCol: DateTableColumn;
    schlachtGrenzeCol: DateTableColumn;
    tageEinstallungCol: TableColumn;
    hitStatusCol: ConditionTableColumn;
    hitSyncCol: DateTableColumn;

    currentUser: KieneSession;

    constructor(
        private dialog: MatDialog,
        private changeCurrentClientService: ChangeCurrentClientService,
        private localStorageService: LocalStorageService,
        private tableService: KieneTableService,
        private messageService: MessageService,
        private router: Router,
        private gruppenService: GruppenService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private fileDownloadService: FileDownloadService,
    ) { }

    ngOnDestroy() {
        this.watchClientSubscription.unsubscribe();
        this.tableService = null;
    }

    ngOnInit(): void {
        this.checkHitPinAktuell();
        // this.checkStripe();

        this.currentUser = this.localStorageService.getCurrentUser();

        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe((response: Client) => {
            this.spaltenEinAusblenden(response);
        });

        this.tableDescriptor.headline = 'Aktuelle Tiergruppen';
        this.tableDescriptor.uniqueIdentifier = 'Aktuelle Gruppen';
        this.tableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'gruppe/read_akt_kundenportal.php';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.initialSortColumn = 'einstalldatum_von';
        this.tableDescriptor.nameOfIdField = 'gruppe_id';
        this.tableDescriptor.route = '/gruppen/aktuelle/';
        this.tableDescriptor.showDetailsVoid = this.goToDetails.bind(this);
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDownloads = true;
        this.tableDescriptor.sendCurrentClient = true;

        this.tableDescriptor.columns = this.getColumns();
        this.spaltenEinAusblenden(this.localStorageService.getCurrentClient());

        this.tableDescriptor.options = this.getOptions();
        this.tableDescriptor.toolbarButtons = this.getToolbarButtons();

        this.tableDescriptor.tooltips['add_button'] = 'Neue Gruppe anlegen';

        this.tableDescriptor.permissionCreate = 9112;

        this.tableDescriptor.totalRow = true;
        this.tableDescriptor.totalRowApiUrl = this.apiBaseUrl + 'gruppe/read_akt_kundenportal_summen.php';
        this.tableDescriptor.addVoid = this.createGruppe.bind(this);
    }

    spaltenEinAusblenden(client: Client) {
        if (client) {
            const rinder: boolean = !!(client.rind > 0);
            if (this.kundeColumn) this.kundeColumn.isActive = false;
            if (this.kundeZusatzColumn) this.kundeZusatzColumn.isActive = false;
            if (this.einstalldatumBisCol) this.einstalldatumBisCol.isActive = rinder;
            if (this.abteilCol) this.abteilCol.isActive = !rinder;
            if (this.sgsCol) this.sgsCol.isActive = rinder;
            if (this.herdenCol) this.herdenCol.isActive = rinder;
            if (this.anzahlAktuellCol) this.anzahlAktuellCol.isActive = true;
            if (this.alterWochenCol) this.alterWochenCol.isActive = rinder;
            if (this.anzahlToteCol) this.anzahlToteCol.isActive = rinder;
            if (this.schlachtIconCol) this.schlachtIconCol.isActive = !client.schwein;
            if (this.schlachtGrenzeCol) this.schlachtGrenzeCol.isActive = !client.schwein;
            if (this.hitStatusCol) this.hitStatusCol.isActive = rinder;
            if (this.hitSyncCol) this.hitSyncCol.isActive = rinder;
            if (this.tageEinstallungCol) this.tageEinstallungCol.isActive = !rinder;
        } else {
            // alles einblenden
            if (this.kundeColumn) this.kundeColumn.isActive = true;
            if (this.kundeZusatzColumn) this.kundeZusatzColumn.isActive = true;
            if (this.einstalldatumBisCol) this.einstalldatumBisCol.isActive = true;
            if (this.abteilCol) this.abteilCol.isActive = true;
            if (this.sgsCol) this.sgsCol.isActive = true;
            if (this.herdenCol) this.herdenCol.isActive = true;
            if (this.anzahlAktuellCol) this.anzahlAktuellCol.isActive = true;
            if (this.alterWochenCol) this.alterWochenCol.isActive = true;
            if (this.anzahlToteCol) this.anzahlToteCol.isActive = true;
            if (this.schlachtIconCol) this.schlachtIconCol.isActive = true;
            if (this.schlachtGrenzeCol) this.schlachtGrenzeCol.isActive = true;
            if (this.hitStatusCol) this.hitStatusCol.isActive = true;
            if (this.hitSyncCol) this.hitSyncCol.isActive = true;
            if (this.tageEinstallungCol) this.tageEinstallungCol.isActive = true;
        }
        this.tableService.updateColumns();
    }

    getColumns(): TableColumn[] {
        const columns = [];
        columns.push(new TableColumn('bezeichnung', 'Gruppenname'));
        columns.push(new TableColumn('produktionsabschnitt', 'Abschnitt'));
        this.herdenCol = new TableColumn('herdenname', 'Herdenname');
        columns.push(this.herdenCol);

        columns.push(new TableColumn('stall', 'Standort'));
        this.abteilCol = new TableColumn('abteil', 'Abteil');
        columns.push(this.abteilCol);
        this.sgsCol = new TableColumn('sgs_nummer', 'SGS Nr.');
        columns.push(this.sgsCol);

        this.kundeColumn = new TableColumn('kunde', 'Kunde');
        this.kundeZusatzColumn = new TableColumn('zusatz', 'Kunde Zusatz');
        columns.push(this.kundeColumn);
        columns.push(this.kundeZusatzColumn);

        columns.push(new DateTableColumn('einstalldatum_von', 'Einstalldatum von', 'dd.MM.yy'));
        this.einstalldatumBisCol = new DateTableColumn('einstalldatum_bis', 'Einstalldatum bis', 'dd.MM.yy');
        columns.push(this.einstalldatumBisCol);
        columns.push(new TableColumn('anzahl_tiere_gesamt', 'Eingestallte Tiere'));
        this.anzahlAktuellCol = new TableColumn('anzahl_tiere_aktuell', 'Anzahl Tiere aktuell');
        columns.push(this.anzahlAktuellCol);
        this.alterWochenCol = new TableColumn('alter_wochen', 'Tieralter in Wo.');
        columns.push(this.alterWochenCol);
        this.anzahlToteCol = new TableColumn('anzahl_tote', 'Tote');
        columns.push(this.anzahlToteCol);
        columns.push(new NumberTableColumn('verluste', 'Verluste', '1.1-1', '%'));
        columns.push(new TableColumn('anzahl_abgaenge', 'Abgänge')); // Verkäufe

        const colorSettings = [
            new ConditionSetting(
                [
                    new Condition(
                        'grenze',
                        Operator.GLEICH,
                        null, //kein Schlachttermin ermittelt
                    ),
                ],
                { color: '', icon: '' },
            ),
            new ConditionSetting(
                [
                    new Condition(
                        'grenze',
                        Operator.GLEICH,
                        1, //jüngstes Tier Schlachttermin in grenze_rot
                    ),
                ],
                { color: '#d50000', icon: 'restaurant' },
            ),
            new ConditionSetting(
                [
                    new Condition(
                        'grenze',
                        Operator.GLEICH,
                        2, //jüngstes Tier Schlachttermin in grenze_gelb
                    ),
                ],
                { color: '#f2c52d', icon: 'restaurant' },
            ),
            new ConditionSetting(
                [
                    new Condition(
                        'grenze',
                        Operator.GLEICH,
                        3, //jüngstes Tier Schlachttermin in grenze_gruen
                    ),
                ],
                { color: '#479864', icon: 'restaurant' },
            ),
            new ConditionSetting(
                [
                    new Condition(
                        'grenze',
                        Operator.GLEICH,
                        4, //jüngstes Tier Schlachttermin später als grenze_gruen
                    ),
                ],
                { color: '#8f8f8f', icon: 'restaurant' },
            ),
            new ConditionSetting(
                [
                    new Condition(
                        'grenze',
                        Operator.GLEICH,
                        6, //jüngstes Tier Schlachttermin in Vergangenheit
                    ),
                ],
                { color: '#a10a0a', icon: 'no_meals' },
            ),
        ];

        this.schlachtIconCol = new ConditionTableColumn('grenze', '', colorSettings, {
            defaultIcon: '',
            defaultColor: '#b6b2b2',
        });
        columns.push(this.schlachtIconCol);

        this.schlachtGrenzeCol = new DateTableColumn('schlachtgrenze', 'Schlachttermin', 'dd.MM.yy');
        columns.push(this.schlachtGrenzeCol);

        this.tageEinstallungCol = new TableColumn('tage_einstallung', 'Tage s. Einstall.');
        columns.push(this.tageEinstallungCol);

        const conditionSettings = [
            new ConditionSetting([new Condition('hit_status_id', Operator.IN, [142, 145])], {
                color: '#479864',
                tooltipFieldnames: ['hit_status_fehler'],
            }),
            new ConditionSetting([new Condition('hit_status_id', Operator.IN, [141, 144])], {
                color: '#f2c52d',
                tooltipFieldnames: ['hit_status_fehler'],
            }),
            new ConditionSetting([new Condition('hit_status_id', Operator.IN, [143])], {
                color: '#d50000',
                tooltipFieldnames: ['hit_status_fehler'],
            }),
        ];

        this.hitStatusCol = new ConditionTableColumn('hit_status_id', 'HIT', conditionSettings, {
            sortFields: ['hit_status_id'],
            defaultIcon: 'cloud_sync',
            defaultColor: '#ddd',
        });
        columns.push(this.hitStatusCol);

        this.hitSyncCol = new DateTableColumn('synchronisiert', 'HIT Sync.', 'dd.MM.yy HH:mm', {
            alternativeField: 'hit_fehler',
        });
        columns.push(this.hitSyncCol);
        columns.push(new KieneBooleanTableColumn('hit_sync_aktiv', 'HIT Sync aktiv'));

        return columns;
    }

    getOptions() {
        const options: TableOption[] = [];
        options.push(
            new TableOption(this.bearbeiten.bind(this), 'Gruppe bearbeiten', 'edit', 9117, {
                conditions: [new Condition('standard', Operator.GLEICH, '0')],
            }),
        );
        options.push(
            new TableOption(this.standortWechseln.bind(this), 'Standort wechseln', 'swap_horiz', 9352, {
                conditions: [
                    new Condition('rind', Operator.GROESSER, 0),
                    new Condition('standard', Operator.GLEICH, '0'),
                ],
            }),
        );
        options.push(
            new TableOption(this.tiereAusHitNachladen.bind(this), 'Tiere mit HIT synchronisieren', 'cloud_sync', 1912, {
                conditions: [new Condition('rind', Operator.GROESSER, 0)],
            }),
        );
        options.push(
            new TableOption(
                this.inHistorieVerschieben.bind(this),
                'Gruppe in Historie verschieben',
                'history_edu',
                9114,
                { conditions: [new Condition('standard', Operator.GLEICH, '0')] },
            ),
        );
        options.push(new TableOption(this.goToDetails.bind(this), 'Detailseite öffnen', 'info', 9111));
        options.push(
            new TableOption(this.openHitSyncEinstellungen.bind(this), 'HIT Sync Einstellung', 'settings', 9195, {
                conditions: [new Condition('standard', Operator.GLEICH, '0')],
            }),
        );
        return options;
    }

    getToolbarButtons(): ToolbarButton[] {
        const buttons = [];
        buttons.push(
            new ToolbarButton(
                this.schlachtdatenNachladen.bind(this),
                'cloud_sync',
                9109,
                'Schlachtdaten aus HIT abfragen',
            ),
        );
        buttons.push(
            new ToolbarButton(this.bestandZuDatumAbfragen.bind(this), 'event', 9109, 'Bestand zu Datum abfragen'),
        );
        return buttons;
    }

    goToDetails(gruppe: Gruppe) {
        if (gruppe?.rind > 0) {
            this.router.navigate(['/gruppen', 'aktuelle', gruppe.gruppe_id]).then();
        } else {
            this.dialog
                .open(GruppeSchweinPopupDialogComponent, { data: gruppe })
                .afterClosed()
                .subscribe({
                    next: () => {
                        this.tableService?.reload('GruppeSchweinPopupDialogComponent');
                    },
                });
        }
    }

    inHistorieVerschieben(gruppe: Gruppe) {
        const input = new ConfirmDialogInput();
        input.headline = 'Gruppe in Historie verschieben?';
        input.text = 'Gruppe in Historie verschieben?';
        input.okButton = 'Verschieben';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '500px', data: input });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.gruppenService.historieAendern(gruppe, true).subscribe({
                    next: () => {
                        this.messageService.infoMessage('Gruppe erfolgreich in Historie verschoben!');
                        this.tableService?.reload();
                    },
                    error: err => {
                        this.messageService.errorMessage('Gruppe konnte nicht in die Historie verschoben werden!', err);
                    },
                });
            }
        });
    }

    tiereAusHitNachladen(gruppe: Gruppe) {
        this.messageService.infoMessage('Tiere werden aus HIT geladen!');
        this.gruppenService.tiereAusHitNachladen(gruppe).subscribe({
            next: () => {
                this.messageService.infoMessage('Tiere erfolgreich aus HIT geladen!');
                this.tableService?.reload();
            },
            error: error => {
                this.messageService.errorMessage('Tiere konnten nicht aus HIT nachgeladen werden!', error);
            },
        });
    }

    createGruppe() {
        if (!this.localStorageService.getCurrentClient()) {
            this.dialog
                .open(ChangeCurrentClientDialogComponent, { width: '50%' })
                .afterClosed()
                .subscribe(result => {
                    if (result?.save && result?.client) {
                        this.localStorageService.setCurrentClient(result.client, 'AktuelleGruppenComponent');
                        this.createGruppe();
                    }
                });
        } else {
            const client = this.localStorageService.getCurrentClient();
            console.log(client);
            if (client.rind > 0) {
                this.createGruppeRind(client);
            } else {
                this.createGruppeSchwein(client);
            }
        }
    }

    createGruppeRind(client: Client) {
        const input = new GruppeDialogInput(client, false, undefined);
        this.dialog
            .open<GruppeDialogComponent, GruppeDialogInput, Gruppe>(GruppeDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (gruppe: Gruppe) => {
                    if (gruppe) {
                        this.router.navigate(['/gruppen', 'aktuelle', gruppe.gruppe_id]).then();
                    } else {
                        this.tableService.reload();
                    }
                },
            });
    }

    createGruppeSchwein(client: Client) {
        const input = new GruppeSchweinDialogInput(client.kunde_id, client.betriebsart_id);
        this.dialog
            .open<GruppeSchweineDialogComponent, GruppeSchweinDialogInput, Gruppe>(GruppeSchweineDialogComponent, {
                data: input,
            })
            .afterClosed()
            .subscribe({
                next: (gruppe: Gruppe) => {
                    if (gruppe) {
                        this.tableService.reload();
                    }
                },
            });
    }

    bearbeiten(gruppe: Gruppe) {
        if (gruppe.rind > 0) {
            this.bearbeitenRind(gruppe);
        } else {
            this.bearbeitenSchwein(gruppe);
        }
    }

    bearbeitenRind(gruppe: Gruppe) {
        const dialogRef = this.dialog.open(GruppeEditDialogComponent, {
            width: '520px',
            maxWidth: '95vw',
            data: { gruppe: gruppe },
        });
        dialogRef.afterClosed().subscribe({
            next: (gruppe1: Gruppe) => {
                if (gruppe1) {
                    this.tableService.reload();
                }
            },
        });
    }

    standortWechseln(gruppe: Gruppe) {
        const dialogRef = this.dialog.open(GruppeStandortWechselnDialogComponent, {
            data: { gruppe: gruppe },
        });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result?.confirm) {
                    this.tableService.reload();
                }
            },
        });
    }

    bearbeitenSchwein(gruppe: Gruppe) {
        const input = new GruppeSchweinDialogInput(gruppe.kunde_id, gruppe.betriebsart_id, { gruppe: gruppe });

        this.dialog
            .open<GruppeSchweineDialogComponent, GruppeSchweinDialogInput, Gruppe>(GruppeSchweineDialogComponent, {
                data: input,
            })
            .afterClosed()
            .subscribe({
                next: (gruppe: Gruppe) => {
                    if (gruppe) {
                        this.tableService.reload();
                    }
                },
            });
    }

    private schlachtdatenNachladen() {
        const client = this.localStorageService.getCurrentClient();
        if (!client) {
            this.messageService.alertMessage('Bitte zunächst oben einen Betrieb auswählen!');
            return;
        }

        this.messageService.infoMessage('Schlachtdaten werden aus HIT geladen!');
        this.gruppenService.schlachtdatenAusHitNachladen(client?.kunde_id).subscribe({
            next: () => {
                this.messageService.infoMessage('Schlachtdaten erfolgreich aus HIT geladen!');
                this.tableService?.reload();
            },
            error: error => {
                this.messageService.errorMessage('Schlachtdaten konnten nicht aus HIT nachgeladen werden!', error);
            },
        });
    }

    /*private checkStripe() {
        this.api.post(this.apiBaseUrl + 'stripe/check.php', undefined).subscribe({
            next: response1 => {
                if (response1?.zahlungsartFehlt === true) {
                    const sessionPojo = new SessionPojo();
                    sessionPojo.returnUrl = window.location.href;
                    this.api.post(this.apiBaseUrl + 'stripe/session.php', sessionPojo).subscribe({
                        next: response2 => {
                            if (response2?.portalUrl) {
                                const input = new ConfirmDialogInput();
                                input.headline = 'Zahlungsmethode hinterlegen';
                                input.text =
                                    'Bitte hinterlegen Sie eine Zahlungsmethode für die (offenen) Rechnungen. Dazu werden Sie auf die Seite unseres Bezahlservices stripe weitergeleitet.';
                                input.showCancel = false;
                                this.dialog
                                    .open(ConfirmDialogComponent, { data: input })
                                    .afterClosed()
                                    .subscribe({
                                        next: () => {
                                            window.open(response2.portalUrl).focus();
                                        },
                                    });
                            }
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler!', err);
                        },
                    });
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }*/

    private checkHitPinAktuell() {
        if (this.localStorageService.currentUserHasPermission(9108)) {
            const params = new HttpParams().set('hit_pin_falsch', '1');
            this.api.get(this.apiBaseUrl + 'kunde/read_pin_falsch.php', params).subscribe({
                next: response => {
                    if (response?.records?.length > 0) {
                        return this.dialog.open(HitPinAktualisierenDialogComponent, {
                            data: response.records,
                            maxWidth: '500px',
                            disableClose: true,
                            closeOnNavigation: false,
                        });
                    }
                },
            });
        }
    }

    private bestandZuDatumAbfragen() {
        const client = this.localStorageService.getCurrentClient();
        if (!client) {
            this.changeCurrentClientService.openChangeDialog().subscribe({
                next: client => {
                    if (client) {
                        this.bestandZuDatumAbfragen();
                    }
                },
            });
        } else {
            const input = new EnterValueInput();
            input.title = 'Bestand zu Datum';
            input.text = 'Bitte geben Sie das Datum ein, zu dem der Bestand abgefragt werden soll.';
            input.okButton = 'Abfragen';
            input.addInputValue('Datum', 'date', new Date());
            this.dialog
                .open(EnterValueDialogComponent, { data: input })
                .afterClosed()
                .subscribe({
                    next: result => {
                        if (result?.result) {
                            this.messageService.infoMessage('Bestand wird abgefragt!');
                            const d = result.getValue(0);
                            const dateFormatted = KieneUtils.formatYYYY_MM_DD(d);
                            const params = new HttpParams()
                                .set('kunde_id', client.kunde_id)
                                .set('datum', dateFormatted);
                            this.fileDownloadService.downloadExcel('kunde/bestand.php', params).subscribe({
                                next: () => {
                                    this.messageService.infoMessage('Bestand erfolgreich abgefragt!');
                                },
                                error: err => {
                                    this.messageService.errorMessage('Bestand konnte nicht abgefragt werden!', err);
                                },
                            });
                        }
                    },
                });
        }
    }

    openHitSyncEinstellungen(gruppe: Gruppe) {
        const input = new HitSyncEinstellungenInput();
        input.gruppe = gruppe;
        this.dialog
            .open(HitSyncEinstellungenDialogComponent, { data: input })
            .afterClosed()
            .subscribe((result: HitSyncEinstellungenResult) => {
                if (result?.confirmed && result.gruppe) {
                    gruppe.hit_sync_aktiv = Number(result.gruppe.hit_sync_aktiv);
                    this.tableService.reload('openHitSyncEinstellungen');
                }
            });
    }
}
